import http from '@/services/http'
import { AddressListObject } from '@/store/addressSlice/types'

export interface ResponseQueryType {
  pageNum: number
  hasNext: boolean
  pageSize: number
  total: number
  data: StoreItemType[]
}

export interface StoreItemType {
  appId: string
  storeId: string
  storeName: string
  storeAlias: string
  storeWebsite: string
  email: string
  status: number
  authStatus: number
  defaultAddressNo: string
  paymentType: number
  refreshPage: () => void
  addressDetail: AddressListObject | null
  [x: string]: any
}

/**
 * 店铺列表
 * @param data
 * @returns
 */
export const getStoreList = async (data) => {
  return await http.admin.post<ResponseQueryType>('/api/store/list', data)
}
